module.exports = __webpack_public_path__ + "img/inactiveicon-kvdr.50245a17.svg";